<div class="ofwca-meeting-list-container">
  <div fxLayout="column" fxLayoutGap="15px">

    <div>
      <table mat-table [dataSource]="ofwcaMeetingDataSource">

        <ng-container matColumnDef="meeting">
          <th mat-header-cell *matHeaderCellDef> Rodzaj </th>
          <td mat-cell *matCellDef="let element">
            <a class="default-link" [routerLink]="['/egzaminy-szkolenia/szczegoly', element.meeting.uuid]">
              {{element.meeting.type.name}}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="logo">
          <th mat-header-cell *matHeaderCellDef [width]="'150px'"> Logo </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            <img *ngIf="element.meeting.insuranceCompany?.imageLocation" src="/rest/crm/insuranceCompany/{{element.meeting?.insuranceCompany?.id}}/image" alt="Zdjęcie" height="30"/>
          </td>
        </ng-container>

        <ng-container matColumnDef="insuranceCompany">
          <th mat-header-cell *matHeaderCellDef> TU </th>
          <td mat-cell *matCellDef="let element">
            <a class="default-link" [routerLink]="['/tu/szczegoly', element.meeting.insuranceCompany?.id]">
              {{element.meeting.insuranceCompany?.name}} ({{element.meeting.insuranceCompany?.type?.name}})
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="examType">
          <th mat-header-cell *matHeaderCellDef> Rodzaj egzaminu </th>
          <td mat-cell *matCellDef="let element">
            {{element.meeting.examType?.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="place">
          <th mat-header-cell *matHeaderCellDef> Typ </th>
          <td mat-cell *matCellDef="let element">
            {{element.meeting.place?.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element">
            <button mat-raised-button [ngClass]="element.meeting.status.color + '-button'">{{element.meeting.status.name}}</button>
          </td>
        </ng-container>

        <ng-container matColumnDef="startsAt">
          <th mat-header-cell *matHeaderCellDef> Data rozpoczęcia </th>
          <td mat-cell *matCellDef="let element">
            {{element.meeting.startsAt | date:'y-MM-dd HH:mm'}} ({{element.meeting.minutesTotal}} min.)
          </td>
        </ng-container>

        <ng-container matColumnDef="passed">
          <th mat-header-cell *matHeaderCellDef> Zaliczone </th>
          <td mat-cell *matCellDef="let element">
            <app-detail-bool [value]="element.passed"></app-detail-bool>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
    </div>

  </div>

</div>
